import { AxiosResponse } from "axios";
import apiClient, {
  CustomAxiosRequestConfig,
} from "../../shared/utils/apiClient";

export const getRealTimeCallApi = async (
  userId: string
): Promise<AxiosResponse> => {
  try {
    const response = await apiClient.get(`realtime/user/call/${userId}`, {
      requiresAuth: true,
    } as CustomAxiosRequestConfig);
    return response;
  } catch (error) {
    console.error("Get Real-Time Call Error:", error);
    throw error;
  }
};
